// extracted by mini-css-extract-plugin
module.exports = {"button":"InviteEmployeesModal_button__XZCYa"};